// extracted by mini-css-extract-plugin
module.exports = {"root":"LocationMap_root__XYcb_","location":"LocationMap_location__zlGlE","title":"LocationMap_title__Ubzyy","img":"LocationMap_img__QpnZ2"};